import React, { useState } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import FormGroup from "react-bootstrap/FormGroup";
import FormLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";

import Axios from "axios";
import { v4 as uuid } from "uuid";

const ResetPassword = ({ match, location }) => {
    const [formData, setFormData] = useState({
        password: "",
        password_confirmation: "",
        digits: ""
    });

    const [alert, setAlert] = useState(alertObj);
    const [disabled, setDisabled] = useState(false);
    const { password, password_confirmation, digits } = formData;
    const { key, variant, message, active } = alert;
    const handleResetPassword = async() => {
        const token = match.params.resetToken;
        const email = new URLSearchParams(location.search).get("email");
        if (!token || !email) {
            setAlert({
                key: uuid(),
                variant: "danger",
                message: "Invalid Request Token",
                active: true
            });
            return;
        }
        try {
            setDisabled(true);
            const response = await Axios.post("/password/reset", {
                password,
                password_confirmation,
                email,
                digits,
                token
            });
            if (response) {
                setAlert({
                    key: uuid(),
                    variant: "success",
                    message: response.data.alert,
                    active: true
                });
            }
            else {
                setAlert({
                    key: uuid(),
                    variant: "danger",
                    message: "Request failed",
                    active: true
                });
            }
            handleAfterRequest(response);
        }
        catch (error) {
            const errorData = error.response.data;
            if (errorData.hasOwnProperty('alert')) {
                setAlert({
                    key: uuid(),
                    variant: "danger",
                    message: errorData.alert,
                    active: true
                });
            }
            if (errorData.hasOwnProperty('errors')) {
                let message = ``;
                 
                for (let key in errorData.errors) {
                    errorData.errors[key].forEach((validationError) => {
                        message += `${validationError} `;
                    });
                }
                setAlert({
                    key: uuid(),
                    variant: "danger",
                    message: message,
                    active: true
                });
            }
            setDisabled(false);
        }
    };
    const handleAfterRequest = response => {
        setTimeout(() => {
            if (response.data.redirect_url) {
                window.location.replace(response.data.redirect_url);
            }
            setAlert(alertObj);
        }, 1500);
    };
    return (
        <Container>
            <Row className="justify-content-center">
                <Col md={8}>
                    {active && (
                        <Alert key={key} variant={variant}>
                            {message}
                        </Alert>
                    )}
                    <Card>
                        <Card.Header>Reset Password</Card.Header>
                        <Card.Body>
                            <FormGroup>
                                <FormLabel htmlFor={"password"}>
                                    Password
                                </FormLabel>
                                <FormControl
                                    type="password"
                                    name="password"
                                    value={password}
                                    required
                                    autoComplete="new-password"
                                    autoFocus
                                    onChange={event =>
                                        setFormData({
                                            ...formData,
                                            [event.target.name]: event.target.value
                                        })
                                    }
                                />
                            </FormGroup>{" "}
                            <FormGroup>
                                <FormLabel htmlFor={"password_confirmation"}>
                                    Confirm Password
                                </FormLabel>
                                <FormControl
                                    type="password"
                                    name="password_confirmation"
                                    value={password_confirmation}
                                    required
                                    autoComplete="new-password"
                                    autoFocus
                                    onChange={event =>
                                        setFormData({
                                            ...formData,
                                            [event.target.name]: event.target.value
                                        })
                                    }
                                />
                            </FormGroup>
                            <FormGroup>
                                <FormLabel htmlFor={"digits"}>
                                    Confirm the last four digits of your phone number
                                </FormLabel>
                                <FormControl
                                    type="digits"
                                    name="digits"
                                    value={digits}
                                    required
                                    autoComplete="digits"
                                    autoFocus
                                    onChange={event =>
                                        setFormData({
                                            ...formData,
                                            [event.target.name]: event.target.value
                                        })
                                    }
                                />
                            </FormGroup>{" "}
                            <Button
                                variant={"primary"}
                                onClick={handleResetPassword}
                                disabled={disabled}
                                className={"mt-4"}
                            >
                                Reset Password
                            </Button>
                        </Card.Body>
                    </Card>
                    <p className="mt-2"><a href="/">Back to login</a></p>
                </Col>
            </Row>
        </Container>
    );
};
const alertObj = {
    key: "",
    message: "",
    variant: "",
    active: false
};

export default ResetPassword;